import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.set.difference.v2.js";
import "core-js/modules/esnext.set.intersection.v2.js";
import "core-js/modules/esnext.set.is-disjoint-from.v2.js";
import "core-js/modules/esnext.set.is-subset-of.v2.js";
import "core-js/modules/esnext.set.is-superset-of.v2.js";
import "core-js/modules/esnext.set.symmetric-difference.v2.js";
import "core-js/modules/esnext.set.union.v2.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, vModelText as _vModelText, withKeys as _withKeys, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1570816c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "question-detail-view"
};
const _hoisted_2 = {
  class: "detail-layout"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "sidebar-header"
}, [/*#__PURE__*/_createElementVNode("h3", null, "题目列表")], -1));
const _hoisted_4 = {
  class: "question-list"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "question-index"
};
const _hoisted_7 = {
  class: "question-title"
};
const _hoisted_8 = {
  key: 0,
  class: "sidebar-vip-tag"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icon-arrow"
}, null, -1));
const _hoisted_10 = [_hoisted_9];
const _hoisted_11 = {
  class: "qdetail-card"
};
const _hoisted_12 = {
  key: 0,
  class: "card-loading-container"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "loading-spinner"
}, null, -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "loading-text"
}, "加载中...", -1));
const _hoisted_15 = [_hoisted_13, _hoisted_14];
const _hoisted_16 = {
  class: "qdetail-header"
};
const _hoisted_17 = {
  class: "qdetail-title-wrapper"
};
const _hoisted_18 = {
  class: "qdetail-title"
};
const _hoisted_19 = {
  class: "qdetail-id"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "btn-emoji"
}, "🔗", -1));
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "btn-emoji"
}, "🌈", -1));
const _hoisted_22 = {
  class: "qdetail-info"
};
const _hoisted_23 = {
  key: 0,
  class: "content-vip-tag"
};
const _hoisted_24 = {
  class: "question-stats"
};
const _hoisted_25 = {
  class: "stat-item"
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "stat-icon"
}, [/*#__PURE__*/_createElementVNode("svg", {
  class: "view-icon",
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
}), /*#__PURE__*/_createElementVNode("circle", {
  cx: "12",
  cy: "12",
  r: "3"
})])], -1));
const _hoisted_27 = {
  class: "stat-value"
};
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "stat-label"
}, "浏览", -1));
const _hoisted_29 = {
  class: "stat-icon"
};
const _hoisted_30 = ["fill"];
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
}, null, -1));
const _hoisted_32 = [_hoisted_31];
const _hoisted_33 = {
  class: "stat-value"
};
const _hoisted_34 = {
  class: "stat-label"
};
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "stat-icon"
}, [/*#__PURE__*/_createElementVNode("svg", {
  class: "star-icon",
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [/*#__PURE__*/_createElementVNode("polygon", {
  points: "12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"
})])], -1));
const _hoisted_36 = {
  class: "stat-value"
};
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "stat-label"
}, "收藏", -1));
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "section-title"
}, "题目描述", -1));
const _hoisted_39 = ["innerHTML"];
const _hoisted_40 = {
  class: "qdetail-card"
};
const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "section-title"
}, "题目解析", -1));
const _hoisted_42 = {
  key: 0,
  class: "card-loading-container"
};
const _hoisted_43 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "loading-spinner"
}, null, -1));
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "loading-text"
}, "加载中...", -1));
const _hoisted_45 = [_hoisted_43, _hoisted_44];
const _hoisted_46 = ["innerHTML"];
const _hoisted_47 = {
  key: 0,
  class: "member-block"
};
const _hoisted_48 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "blur-overlay"
}, null, -1));
const _hoisted_49 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "成为会员，解锁完整题解", -1));
const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "加入会员，获取海量面试题解，提升面试通过率", -1));
const _hoisted_51 = {
  class: "comments-section"
};
const _hoisted_52 = {
  class: "comments-title"
};
const _hoisted_53 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "title-emoji"
}, "💭", -1));
const _hoisted_54 = {
  class: "comments-count"
};
const _hoisted_55 = {
  class: "comment-input-wrapper"
};
const _hoisted_56 = {
  class: "user-avatar"
};
const _hoisted_57 = ["src"];
const _hoisted_58 = {
  class: "comment-input-container"
};
const _hoisted_59 = ["placeholder", "onKeydown"];
const _hoisted_60 = {
  class: "comment-tools"
};
const _hoisted_61 = {
  class: "comment-tools-left"
};
const _hoisted_62 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "comment-tip"
}, "Ctrl + Enter 发送", -1));
const _hoisted_63 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "btn-emoji"
}, "✨", -1));
const _hoisted_64 = {
  class: "comments-list"
};
const _hoisted_65 = {
  class: "comment-avatar"
};
const _hoisted_66 = ["src", "alt"];
const _hoisted_67 = {
  class: "comment-content"
};
const _hoisted_68 = {
  class: "comment-header"
};
const _hoisted_69 = {
  class: "comment-username"
};
const _hoisted_70 = {
  class: "comment-time"
};
const _hoisted_71 = {
  class: "comment-text"
};
const _hoisted_72 = {
  class: "comment-actions"
};
const _hoisted_73 = ["onClick"];
const _hoisted_74 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "action-icon"
}, "👍", -1));
const _hoisted_75 = {
  class: "action-count"
};
const _hoisted_76 = ["onClick"];
const _hoisted_77 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "action-icon"
}, "💬", -1));
const _hoisted_78 = {
  class: "more-menu-wrapper",
  style: {
    "position": "relative",
    "display": "inline-block"
  }
};
const _hoisted_79 = ["onClick"];
const _hoisted_80 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "action-icon"
}, "⋯", -1));
const _hoisted_81 = [_hoisted_80];
const _hoisted_82 = ["onClick"];
const _hoisted_83 = ["onClick"];
const _hoisted_84 = {
  key: 0,
  class: "reply-list"
};
const _hoisted_85 = {
  class: "reply-content"
};
const _hoisted_86 = {
  class: "reply-header"
};
const _hoisted_87 = {
  class: "reply-user-info"
};
const _hoisted_88 = ["src", "alt"];
const _hoisted_89 = {
  class: "reply-meta"
};
const _hoisted_90 = {
  class: "reply-username"
};
const _hoisted_91 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "reply-to"
}, "回复", -1));
const _hoisted_92 = {
  class: "reply-target"
};
const _hoisted_93 = {
  class: "reply-time"
};
const _hoisted_94 = {
  class: "reply-text"
};
const _hoisted_95 = {
  class: "reply-actions"
};
const _hoisted_96 = ["onClick"];
const _hoisted_97 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "action-icon"
}, "👍", -1));
const _hoisted_98 = {
  class: "action-count"
};
const _hoisted_99 = ["onClick"];
const _hoisted_100 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "action-icon"
}, "💬", -1));
const _hoisted_101 = {
  class: "more-menu-wrapper",
  style: {
    "position": "relative",
    "display": "inline-block"
  }
};
const _hoisted_102 = ["onClick"];
const _hoisted_103 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "action-icon"
}, "⋯", -1));
const _hoisted_104 = [_hoisted_103];
const _hoisted_105 = ["onClick"];
const _hoisted_106 = ["onClick"];
const _hoisted_107 = {
  class: "report-dialog-content"
};
const _hoisted_108 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "report-tip"
}, "请选择举报原因：", -1));
const _hoisted_109 = {
  key: 0,
  class: "custom-reason-input"
};
const _hoisted_110 = {
  class: "dialog-footer"
};
const _hoisted_111 = {
  key: 0
};
const _hoisted_112 = {
  key: 1
};
import { ref, computed, onMounted, watch, onUnmounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { marked } from 'marked';
import "github-markdown-css/github-markdown-light.css";
import myAxios from "@/plugins/myAxios";
import ACCESS_ENUM from "@/access/ACCESS_ENUM";
import { useLoginUserStore } from "@/store/loginUser";
import { message } from 'ant-design-vue';
import { ElMessage, ElMessageBox } from "element-plus";
const pageSize = 20;
export default {
  __name: 'InterviewQuestionDetail',
  setup(__props) {
    const loginUserStore = useLoginUserStore();
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const question = ref({
      id: 0,
      title: '',
      difficulty: '',
      description: '',
      solution: '',
      isFree: 0,
      likes: 0,
      views: 0,
      collects: 0
    });

    // 监听路由参数变化
    watch(() => route.params.id, newId => {
      if (newId) {
        getInterviewQuestionDetail(newId);
        getAllComments(newId);
      }
    });
    onMounted(() => {
      getInterviewQuestionDetail(route.params.id);
    });
    const getInterviewQuestionDetail = async id => {
      isLoading.value = true;
      try {
        // 1. 首先获取题目的基本信息
        const partialRes = await getPartInterviewQuestionDetail(id);
        if (partialRes?.data?.code === 200) {
          const {
            isFree,
            ...questionData
          } = partialRes.data.data;
          // 2. 判断是否需要获取完整题目信息
          // 条件：题目免费 或 用户是VIP
          if (parseInt(isFree) === 0 || loginUserStore.loginUser?.userRole === ACCESS_ENUM.VIP_GOLD) {
            const fullRes = await getWholeInterviewQuestionDetail(id);
            if (fullRes?.data?.code === 200) {
              // 更新完整题目信息
              const fullData = fullRes.data.data;
              question.value = {
                id: fullData.id,
                title: fullData.name,
                difficulty: fullData.difficult,
                description: fullData.content,
                solution: fullData.solveContent,
                isFree: fullData.isFree,
                likes: fullData.good,
                views: fullData.watch,
                favorites: fullData.collect
              };
            }
          } else {
            const partialData = partialRes.data.data;
            question.value = {
              id: partialData.id,
              title: partialData.name,
              difficulty: partialData.difficult,
              description: partialData.content,
              solution: partialData.solveContent,
              isFree: partialData.isFree,
              likes: partialData.good,
              views: partialData.watch,
              favorites: partialData.collect
            };
          }

          // 3. 增加浏览量
          await increaseViewCount(id);

          // 4. 如果用户已登录，检查点赞状态和收藏状态
          if (loginUserStore.isLogin) {
            await checkLikeStatus(id);
            await checkFavoriteStatus(id);
          }
        }
      } catch (error) {
        console.error('获取题目详情失败:', error);
        ElMessage.error('获取题目详情失败');
      } finally {
        isLoading.value = false;
      }
    };

    // 增加浏览量的函数
    const increaseViewCount = async id => {
      try {
        const res = await myAxios.post(`/baseinfo/fronted/increaseViewCount/${id}`);
        if (res?.data?.code === 200) {
          // 更新本地浏览量显示
          question.value.views = parseInt(question.value.views || 0);
        }
      } catch (error) {
        console.error('增加浏览量失败:', error);
        // 这里我们不向用户显示错误，因为这不影响核心功能
      }
    };
    const getPartInterviewQuestionDetail = async id => {
      try {
        return await myAxios.get("/baseinfo/fronted/getInterviewDetailByIdNotMember", {
          params: {
            id
          }
        });
      } catch (error) {
        console.error('获取部分题目详情出错:', error);
        throw error;
      }
    };
    const getWholeInterviewQuestionDetail = async id => {
      try {
        return await myAxios.get("/baseinfo/fronted/getInterviewDetailByIdMember", {
          params: {
            id
          }
        });
      } catch (error) {
        console.error('获取完整题目详情出错:', error);
        throw error;
      }
    };

    // 将Markdown转换为HTML
    const formattedDescription = computed(() => {
      if (!question.value.description) return '';
      return marked.parse(question.value.description);
    });
    const formattedSolution = computed(() => {
      if (!question.value.solution) return '';
      return marked.parse(question.value.solution);
    });

    // 计算是否有完整访问权限
    const isFullAccess = computed(() => {
      return question.value.isFree === 0 || loginUserStore.loginUser?.userRole === ACCESS_ENUM.VIP_GOLD;
    });

    // 添加复制处理函数
    // 添加复制处理函数
    const handleCopy = e => {
      e.preventDefault(); // 阻止默认复制行为，统一处理

      // 获取登录用户信息
      const userRole = loginUserStore.loginUser?.userRole;

      // 限制非黄金会员用户
      if (userRole === ACCESS_ENUM.NOT_LOGIN || userRole === ACCESS_ENUM.USER || userRole === ACCESS_ENUM.VIP) {
        // ElMessage.error('成为黄金会员后可复制内容~');
        return;
      }

      // 获取用户选中的内容
      const selection = window.getSelection();
      const selectedText = selection.toString();

      // 检查是否有选中的内容
      if (!selectedText) {
        // ElMessage.error('请先选中内容后再复制');
        return;
      }

      // 使用 Clipboard API 复制选中的内容
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(selectedText).then(() => {
          // ElMessage.success('复制成功');
        }).catch(() => {
          // ElMessage.error('复制失败，请重试');
        });
      } else {
        // 回退方案
        const textarea = document.createElement('textarea');
        textarea.value = selectedText;
        document.body.appendChild(textarea);
        textarea.select();
        try {
          document.execCommand('copy');
          // ElMessage.success('复制成功');
        } catch (err) {
          // ElMessage.error('复制失败，请重试');
        } finally {
          document.body.removeChild(textarea);
        }
      }
    };

    // 用户状态
    const isLiked = ref(false);
    const isFavorited = ref(false);
    // 添加节流标志位
    const isLikeLoading = ref(false);
    const isCommentLikeLoading = ref(false); // 评论点赞状态标志
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const userAvatar = ref(require('@/assets/xiaoniu-logo.png')); // 替换为实际的用户头像
    const newComment = ref('');

    // 修改评论数据结构，添加回复数组
    const comments = ref([]);
    onMounted(() => {
      // 初始化数据 查询评论数据
      getAllComments(route.params.id);
    });

    /**
     * 处理头像路径，确保正确解析为可用的 URL
     * @param {string} avatar 头像路径
     * @returns {string} 解析后的图片 URL
     */
    const resolveAvatar = avatar => {
      // 如果 avatar 是有效的 URL，直接返回
      if (avatar && avatar.trim() && !avatar.includes('require')) {
        return avatar;
      }
      try {
        // Vite 兼容写法
        return new URL('@/assets/xiaoniu-logo.png', import.meta.url).href;
      } catch (e) {
        // Webpack 兼容写法
        return require('@/assets/xiaoniu-logo.png');
      }
    };
    const getAllComments = async id => {
      try {
        const res = await myAxios.get(`/baseinfo/fronted/getInterviewComment/${id}`);
        if (res?.data?.code === 200) {
          if (res.data.data && res.data.data.length > 0) {
            // 获取评论数据
            comments.value = res.data.data.map(comment => ({
              ...comment,
              // 处理 username: 如果 null 或空字符串，设置为 "未知用户"
              username: comment.username?.trim() || '未知用户',
              // 处理 avatar: 如果 null 或空字符串，设置为默认图片路径
              avatar: comment.avatar?.trim() || require('@/assets/xiaoniu-logo.png'),
              // 添加点赞状态
              isLiked: false,
              // 处理回复评论
              replies: comment.replies?.length > 0 ? comment.replies.map(reply => ({
                ...reply,
                username: reply.username?.trim() || '未知用户',
                avatar: reply.avatar?.trim() || require('@/assets/xiaoniu-logo.png'),
                replayUserName: reply.replayUserName?.trim() || '未知用户',
                // 添加点赞状态
                isLiked: false
              })) : [] // 如果没有回复，返回空数组
            }));

            // 如果用户已登录，获取用户点赞状态
            if (loginUserStore.isLogin) {
              await checkCommentsLikeStatus();
            }
          }
        } else {
          ElMessage.error('获取评论失败');
        }
      } catch (error) {
        ElMessage.error('获取评论失败: ' + error.message);
      }
    };

    // 检查用户对评论的点赞状态
    const checkCommentsLikeStatus = async () => {
      try {
        // 收集所有评论和回复的ID
        const commentIds = [];
        comments.value.forEach(comment => {
          commentIds.push(comment.id);
          if (comment.replies && comment.replies.length > 0) {
            comment.replies.forEach(reply => {
              commentIds.push(reply.id);
            });
          }
        });
        if (commentIds.length === 0) return;

        // 批量获取点赞状态
        const res = await myAxios.post('/baseinfo/fronted/batchCheckCommentLikes', {
          commentIds: commentIds
        });
        if (res?.data?.code === 200 && res.data.data) {
          const likedCommentIds = new Set(res.data.data);

          // 更新评论和回复的点赞状态
          comments.value.forEach(comment => {
            comment.isLiked = likedCommentIds.has(comment.id);
            if (comment.replies && comment.replies.length > 0) {
              comment.replies.forEach(reply => {
                reply.isLiked = likedCommentIds.has(reply.id);
              });
            }
          });
        }
      } catch (error) {
        console.error('获取评论点赞状态失败:', error);
        // 这里不显示错误信息给用户，因为这不影响核心功能
      }
    };

    // 添加举报功能
    const reportComment = (comment, isReply = false) => {
      // 检查用户是否登录
      if (!loginUserStore.isLogin) {
        ElMessage.error("您尚未登录~");
        return;
      }

      // 保存当前举报目标
      currentReportTarget.value = comment;
      isReportReply.value = isReply;

      // 重置举报表单
      reportReason.value = '';
      customReportReason.value = '';

      // 显示举报对话框
      reportDialogVisible.value = true;
    };

    // 提交举报
    const submitReport = async () => {
      // 验证举报原因
      if (!reportReason.value) {
        ElMessage.warning('请选择举报原因');
        return;
      }
      if (reportReason.value === '其他' && !customReportReason.value.trim()) {
        ElMessage.warning('请填写具体举报原因');
        return;
      }

      // 准备举报数据
      const reportData = {
        commentId: currentReportTarget.value.id,
        reason: reportReason.value === '其他' ? customReportReason.value : reportReason.value
        // commentType: isReportReply.value ? 'reply' : 'comment',
        // commentContent: currentReportTarget.value.content,
        // commentUserId: currentReportTarget.value.userId || 0
      };
      try {
        isSubmittingReport.value = true;

        // 调用API提交举报
        const res = await myAxios.post('/baseinfo/fronted/reportComment', reportData);
        if (res?.data?.code === 200) {
          ElMessage.success('举报成功，我们会尽快处理');
          reportDialogVisible.value = false;
        } else {
          ElMessage.error(res?.data?.msg || '举报失败，请稍后重试');
        }
      } catch (error) {
        console.error('举报评论失败:', error);
        ElMessage.error('举报失败，请稍后重试');
      } finally {
        isSubmittingReport.value = false;
      }
    };

    // 当前回复状态
    const replyState = ref({
      isReplying: false,
      parentId: null,
      replayUserName: null,
      replayUserId: null,
      isSecondLevel: false // 添加是否为二级回复的标记
    });

    // 修改回复方法
    const replyComment = (comment, isMainComment = true) => {
      const parentComment = isMainComment ? comment : comments.value.find(c => c.id === comment.parentId);
      replyState.value = {
        isReplying: true,
        parentId: parentComment.id,
        replayUserName: comment.username,
        replayUserId: comment.userId,
        isSecondLevel: !isMainComment
      };

      // 自动滚动到评论框
      const commentInput = document.querySelector('.comment-input');
      if (commentInput) {
        commentInput.focus();
        commentInput.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    };

    // 取消回复
    const cancelReply = () => {
      replyState.value = {
        isReplying: false,
        parentId: null,
        replayUserName: null,
        isSecondLevel: false
      };
      newComment.value = '';
    };

    // 修改提交评论方法
    // const submitComment = () => {
    //   if (!newComment.value.trim()) return;
    //
    //   const commentContent = newComment.value;
    //
    //   if (replyState.value.isReplying) {
    //     // 添加回复
    //     const parentComment = comments.value.find(c => c.id === replyState.value.parentId);
    //     if (parentComment) {
    //       const newReply = {
    //         id: Date.now(),
    //         username: loginUserStore.loginUser.userName || '当前用户',
    //         avatar: userAvatar.value,
    //         content: commentContent,
    //         time: '刚刚',
    //         likes: 0,
    //         replayUserName: replyState.value.replayUserName,
    //         parentId: parentComment.id
    //       };
    //       parentComment.replies.push(newReply);
    //     }
    //     cancelReply();
    //   } else {
    //     // 添加主评论
    //     comments.value.unshift({
    //       id: Date.now(),
    //       username: loginUserStore.loginUser.userName || '当前用户',
    //       avatar: userAvatar.value,
    //       content: commentContent,
    //       time: '刚刚',
    //       likes: 0,
    //       replies: []
    //     });
    //   }
    //
    //   newComment.value = '';
    // };

    const submitComment = async () => {
      if (!newComment.value.trim()) return;
      const commentContent = newComment.value;
      const user = loginUserStore.loginUser;
      if (!loginUserStore.isLogin) {
        ElMessage.error("您尚未登录~");
        return;
      }
      const maxCommentLength = 1000;
      if (newComment.value.trim().length > maxCommentLength) {
        ElMessage.error(`您评论的内容太长啦~`);
        return;
      }
      if (replyState.value.isReplying) {
        // 添加回复
        const res = await myAxios.post('/baseinfo/fronted/addInterviewReply', {
          parentCommentId: replyState.value.parentId,
          content: commentContent,
          replyUserId: replyState.value.replayUserId,
          replayUsername: replyState.value.replayUserName,
          userId: user.userId || null,
          titleId: question.value.id,
          titleName: question.value.title
        });
        if (res?.data?.code !== 200) {
          ElMessage.error(res?.data?.message || '回复评论失败');
        }
        const newReply = res.data.data;
        const parentComment = comments.value.find(c => c.id === replyState.value.parentId);
        if (parentComment) {
          parentComment.replies.push({
            id: newReply.id || Date.now(),
            username: newReply.username || '当前用户',
            avatar: newReply.avatar || userAvatar.value,
            content: newReply.content,
            time: newReply.time || '刚刚',
            likes: newReply.likes || 0,
            replayUserName: newReply.replayUserName,
            parentId: parentComment.id
          });
          ElMessage.success('回复成功~');
        }
        cancelReply();
      } else {
        // 添加主评论
        const res = await myAxios.post('/baseinfo/fronted/addInterviewComment', {
          content: commentContent,
          titleId: question.value.id,
          titleName: question.value.title
        });
        if (res?.data?.code !== 200) {
          ElMessage.error(res?.data?.message || '提交评论失败');
        }
        const newCommentData = res.data.data;
        comments.value.unshift({
          id: newCommentData.id || Date.now(),
          username: newCommentData.username || '当前用户',
          avatar: newCommentData.avatar || userAvatar.value,
          content: newCommentData.content,
          time: newCommentData.time || '刚刚',
          likes: newCommentData.likes || 0,
          replies: []
        });
        ElMessage.success('评论成功~');
      }
      newComment.value = '';
    };

    // 点赞/收藏切换
    const toggleLike = async () => {
      try {
        //检查一下用户是否登录
        if (!loginUserStore.isLogin) {
          ElMessage.error("您尚未登录~");
          return;
        }

        // 如果正在处理中，直接返回
        if (isLikeLoading.value) {
          ElMessage.warning("操作太频繁了，请稍后再试~");
          return;
        }

        // 设置处理中状态
        isLikeLoading.value = true;
        const url = isLiked.value ? `/baseinfo/fronted/decreaseGood/${question.value.id}` : `/baseinfo/fronted/increaseGood/${question.value.id}`;
        const res = await myAxios.post(url);
        if (res?.data?.code === 200) {
          isLiked.value = !isLiked.value;
          if (isLiked.value) {
            question.value.likes++;
            ElMessage.success('点赞成功');
          } else {
            question.value.likes--;
            ElMessage.success('已取消点赞');
          }
        } else {
          ElMessage.error(res?.data?.msg || '操作失败');
        }
      } catch (error) {
        ElMessage.error('操作失败，请稍后重试');
      } finally {
        // 设置一个延迟，防止快速点击
        setTimeout(() => {
          isLikeLoading.value = false;
        }, 1000); // 1秒后才能再次点击
      }
    };
    const toggleFavorite = async () => {
      try {
        // 检查用户是否登录
        if (!loginUserStore.isLogin) {
          ElMessage.error("您尚未登录~");
          return;
        }

        // 如果正在处理中，直接返回
        if (isLikeLoading.value) {
          ElMessage.warning("操作太频繁了，请稍后再试~");
          return;
        }

        // 设置处理中状态
        isLikeLoading.value = true;
        const url = isFavorited.value ? `/baseinfo/fronted/decreaseCollect/${question.value.id}` : `/baseinfo/fronted/increaseCollect/${question.value.id}`;
        const res = await myAxios.post(url);
        if (res?.data?.code === 200) {
          isFavorited.value = !isFavorited.value;
          if (isFavorited.value) {
            question.value.favorites++;
            ElMessage.success('收藏成功');
          } else {
            question.value.favorites--;
            ElMessage.success('已取消收藏');
          }
        } else {
          ElMessage.error(res?.data?.msg || '操作失败');
        }
      } catch (error) {
        ElMessage.error('操作失败，请稍后重试');
      } finally {
        // 设置一个延迟，防止快速点击
        setTimeout(() => {
          isLikeLoading.value = false;
        }, 1000); // 1秒后才能再次点击
      }
    };

    // 评论相关功能
    const likeComment = async comment => {
      // 检查用户是否登录
      if (!loginUserStore.isLogin) {
        ElMessage.error("您尚未登录~");
        return;
      }

      // 如果正在处理中，直接返回
      if (isCommentLikeLoading.value) {
        ElMessage.warning("操作太频繁了，请稍后再试~");
        return;
      }

      // 设置处理中状态
      isCommentLikeLoading.value = true;
      try {
        // 准备API请求参数
        const commentId = comment.id;
        const isLiked = comment.isLiked;

        // 根据当前点赞状态决定调用哪个接口
        const url = isLiked ? `/baseinfo/fronted/cancelCommentLike/${commentId}` : `/baseinfo/fronted/addCommentLike/${commentId}`;

        // 乐观更新UI，提高用户体验
        comment.isLiked = !comment.isLiked;
        if (comment.isLiked) {
          comment.likes++;
        } else {
          comment.likes = Math.max(0, comment.likes - 1); // 防止出现负数
        }

        // 调用API
        const res = await myAxios.post(url);
        if (res?.data?.code === 200) {
          // 请求成功，显示提示
          if (comment.isLiked) {
            ElMessage.success('点赞成功!');
          } else {
            ElMessage.success('取消点赞');
          }
        } else {
          // 请求失败，回滚UI状态
          comment.isLiked = !comment.isLiked;
          if (comment.isLiked) {
            comment.likes++;
          } else {
            comment.likes = Math.max(0, comment.likes - 1);
          }
          ElMessage.error(res?.data?.msg || '操作失败，请稍后重试');
        }
      } catch (error) {
        // 发生异常，回滚UI状态
        comment.isLiked = !comment.isLiked;
        if (comment.isLiked) {
          comment.likes++;
        } else {
          comment.likes = Math.max(0, comment.likes - 1);
        }
        ElMessage.error('操作失败，请稍后重试');
      } finally {
        // 请求完成后重置状态
        isCommentLikeLoading.value = false;
      }
    };

    // 删除主评论
    const deleteComment = async comment => {
      // 弹出确认框
      ElMessageBox.confirm('您确定要删除这条评论吗？', '确认删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const response = await myAxios.delete(`/baseinfo/fronted/removeInterviewComment/${comment.id}`);
          if (response.data.code === 200) {
            // 从评论列表中移除已删除的评论
            comments.value = comments.value.filter(c => c.id !== comment.id);
            ElMessage.success('评论删除成功');
          } else {
            ElMessage.error(response.data.message);
          }
        } catch (error) {
          ElMessage.error('删除评论失败，请稍后重试');
        }
      }).catch(() => {
        // 用户点击取消时的处理
        ElMessage.info('已取消删除');
      });
    };

    // 删除回复
    const deleteReply = async (parentComment, reply) => {
      // 弹出确认框
      ElMessageBox.confirm('您确定要删除这条回复吗？', '确认删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const response = await myAxios.delete(`/baseinfo/fronted/removeInterviewComment/${reply.id}`);
          if (response.data.code === 200) {
            // 从父评论的回复列表中移除已删除的回复
            parentComment.replies = parentComment.replies.filter(r => r.id !== reply.id);
            ElMessage.success('回复删除成功');
          } else {
            ElMessage.error(response.data.message);
          }
        } catch (error) {
          ElMessage.error('删除回复失败，请稍后重试');
        }
      }).catch(() => {
        // 用户点击取消时的处理
        ElMessage.info('已取消删除');
      });
    };

    // 返回上一页
    function goBack() {
      router.push(`/business/interview/detail/${profileId.value}/${profileName.value}`);
    }

    // 跳转到会员页面
    function goToMemberPage() {
      router.push('/member');
    }

    // 难度标签
    function difficultyLabel(diff) {
      const labels = {
        easy: '简单',
        medium: '中等',
        hard: '困难'
      };
      return labels[diff] || diff;
    }

    // 侧边栏状态
    const isSidebarCollapsed = ref(false);
    const questionList = ref([]);
    const currentPage = ref(1);
    const hasMore = ref(true);
    const isLoading = ref(false);
    const profileId = ref(route.params.profileId);
    const profileName = ref(route.params.profileName);

    // 模拟从后端获取题目列表
    async function fetchQuestions(page) {
      isLoading.value = true;
      try {
        const res = await myAxios.get('/baseinfo/fronted/getInterViewQuestionsById', {
          params: {
            profileId: profileId.value
          }
        });
        if (res?.data?.code === 200) {
          const responseData = res.data.data;
          // 将API返回的数据映射到所需的格式
          const formattedData = responseData.map(item => ({
            id: item.id,
            title: item.name,
            difficulty: item.difficult,
            vip: item.isFree === 1 // 如果isFree为1则表示是VIP题目
          }));
          questionList.value = page === 1 ? formattedData : [...questionList.value, ...formattedData];

          // 根据返回的数据长度判断是否还有更多数据
          hasMore.value = formattedData.length === pageSize;
          currentPage.value = page;
        } else {
          console.error('Failed to fetch questions:', res?.data?.msg);
        }
      } catch (error) {
        console.error('Failed to fetch questions:', error);
      } finally {
        isLoading.value = false;
      }
    }

    // 懒加载更多题目
    async function loadMoreQuestions(entries) {
      if (entries[0].isIntersecting && hasMore.value && !isLoading.value) {
        await fetchQuestions(currentPage.value + 1);
      }
    }

    // 切换侧边栏
    function toggleSidebar() {
      isSidebarCollapsed.value = !isSidebarCollapsed.value;
    }

    // 跳转到指定题目
    function goToQuestion(id) {
      // 如果是同一个题目，不需要跳转
      if (id === Number(route.params.id)) {
        return;
      }
      //清除评论的缓存
      comments.value = [];
      router.push(`/business/interview/question/${profileId.value}/${profileName.value}/${id}`);
    }

    // 初始化加载
    onMounted(() => {
      fetchQuestions(1);
    });

    // 分享题目
    const shareQuestion = () => {
      // 获取当前页面的URL
      const currentUrl = window.location.href;

      // 创建临时输入框
      const tempInput = document.createElement('input');
      tempInput.value = currentUrl;
      document.body.appendChild(tempInput);

      // 选择内容
      tempInput.select();
      tempInput.setSelectionRange(0, 99999); // 兼容移动端

      try {
        // 执行复制命令
        document.execCommand('copy');
        // 显示成功消息
        message.success('链接已复制到剪贴板');
      } catch (err) {
        // 如果复制失败，尝试使用新的 Clipboard API
        navigator.clipboard.writeText(currentUrl).then(() => {
          message.success('链接已复制到剪贴板');
        }).catch(() => {
          message.error('复制失败，请手动复制');
        });
      } finally {
        // 移除临时输入框
        document.body.removeChild(tempInput);
      }
    };

    // 添加检查点赞状态的方法
    const checkLikeStatus = async id => {
      try {
        const res = await myAxios.get(`/baseinfo/fronted/checkUserLike/${id}`);
        if (res?.data?.code === 200) {
          isLiked.value = res.data.data;
        }
      } catch (error) {
        console.error('获取点赞状态失败:', error);
        // 这里我们不向用户显示错误，因为这不影响核心功能
      }
    };

    // 添加检查收藏状态的方法
    const checkFavoriteStatus = async id => {
      try {
        const res = await myAxios.get(`/baseinfo/fronted/checkUserCollect/${id}`);
        if (res?.data?.code === 200) {
          isFavorited.value = res.data.data;
        }
      } catch (error) {
        console.error('获取收藏状态失败:', error);
        // 这里我们不向用户显示错误，因为这不影响核心功能
      }
    };

    // 监听登录状态变化
    watch(() => loginUserStore.isLogin, async newVal => {
      if (newVal && question.value.id) {
        await checkLikeStatus(question.value.id);
        await checkFavoriteStatus(question.value.id);
        // 检查评论点赞状态
        if (comments.value.length > 0) {
          await checkCommentsLikeStatus();
        }
      } else {
        isLiked.value = false;
        isFavorited.value = false;
        // 重置所有评论的点赞状态
        comments.value.forEach(comment => {
          comment.isLiked = false;
          if (comment.replies && comment.replies.length > 0) {
            comment.replies.forEach(reply => {
              reply.isLiked = false;
            });
          }
        });
      }
    });

    // 更多操作菜单状态
    const moreMenuState = ref({
      commentId: null,
      // 当前展开菜单的评论/回复id
      isReply: false // 是否为回复
    });
    const toggleMoreMenu = (id, isReply) => {
      if (moreMenuState.value.commentId === id && moreMenuState.value.isReply === isReply) {
        moreMenuState.value = {
          commentId: null,
          isReply: false
        };
      } else {
        moreMenuState.value = {
          commentId: id,
          isReply
        };
      }
    };
    const closeMoreMenu = () => {
      moreMenuState.value = {
        commentId: null,
        isReply: false
      };
    };
    document.addEventListener('click', closeMoreMenu);
    onUnmounted(() => {
      document.removeEventListener('click', closeMoreMenu);
    });

    // 举报相关状态
    const reportDialogVisible = ref(false);
    const reportReason = ref('');
    const customReportReason = ref('');
    const reportReasons = ['垃圾广告', '色情低俗', '政治敏感', '违法信息', '侮辱谩骂', '诱导行为', '其他'];
    const currentReportTarget = ref(null);
    const isReportReply = ref(false);
    const isSubmittingReport = ref(false);

    // 计算当前题目在列表中的索引
    const currentQuestionIndex = computed(() => {
      const index = questionList.value.findIndex(q => q.id === Number(question.value.id));
      return index !== -1 ? index + 1 : question.value.id;
    });
    return (_ctx, _cache) => {
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_highlight = _resolveDirective("highlight");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
        class: _normalizeClass(["sidebar", {
          'sidebar-collapsed': isSidebarCollapsed.value
        }])
      }, [_hoisted_3, _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questionList.value, (q, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: q.id,
          class: _normalizeClass(["question-item", {
            active: q.id === Number(question.value.id)
          }]),
          onClick: $event => goToQuestion(q.id)
        }, [_createElementVNode("span", _hoisted_6, "#" + _toDisplayString(index + 1), 1), _createElementVNode("span", _hoisted_7, _toDisplayString(q.title), 1), _createElementVNode("span", {
          class: _normalizeClass(["question-difficulty", 'diff-' + q.difficulty])
        }, _toDisplayString(difficultyLabel(q.difficulty)), 3), q.vip ? (_openBlock(), _createElementBlock("span", _hoisted_8, "VIP")) : _createCommentVNode("", true)], 10, _hoisted_5);
      }), 128))]), _createElementVNode("div", {
        class: "collapse-btn-wrapper"
      }, [_createElementVNode("button", {
        class: "collapse-btn",
        onClick: toggleSidebar
      }, _hoisted_10)])], 2), _createElementVNode("div", {
        class: _normalizeClass(["main-content", {
          collapsed: isSidebarCollapsed.value
        }])
      }, [_createElementVNode("div", _hoisted_11, [isLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_15)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("h1", _hoisted_18, [_createElementVNode("span", _hoisted_19, "#" + _toDisplayString(currentQuestionIndex.value), 1), _createTextVNode(" " + _toDisplayString(question.value.title), 1)]), _createElementVNode("div", {
        class: "header-actions"
      }, [_createElementVNode("button", {
        class: "share-btn",
        onClick: shareQuestion
      }, [_hoisted_20, _createTextVNode(" 分享题目 ")]), _createElementVNode("button", {
        class: "qdetail-back",
        onClick: goBack
      }, [_hoisted_21, _createTextVNode(" 返回题目列表 ")])])]), _createElementVNode("div", _hoisted_22, [_createElementVNode("span", {
        class: _normalizeClass(["qdetail-difficulty", 'diff-' + question.value.difficulty])
      }, _toDisplayString(difficultyLabel(question.value.difficulty)), 3), question.value.isFree === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_23, " VIP ")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_hoisted_26, _createElementVNode("span", _hoisted_27, _toDisplayString(question.value.views || 0), 1), _hoisted_28]), _createElementVNode("div", {
        class: _normalizeClass(["stat-item like-button", {
          'active': isLiked.value
        }]),
        onClick: toggleLike
      }, [_createElementVNode("span", _hoisted_29, [(_openBlock(), _createElementBlock("svg", {
        class: "like-icon",
        viewBox: "0 0 24 24",
        width: "1.2em",
        height: "1.2em",
        fill: isLiked.value ? 'currentColor' : 'none',
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, _hoisted_32, 8, _hoisted_30))]), _createElementVNode("span", _hoisted_33, _toDisplayString(question.value.likes || 0), 1), _createElementVNode("span", _hoisted_34, _toDisplayString(isLiked.value ? '已点赞' : '点赞'), 1)], 2), _createElementVNode("div", {
        class: _normalizeClass(["stat-item", {
          'active': isFavorited.value
        }]),
        onClick: toggleFavorite
      }, [_hoisted_35, _createElementVNode("span", _hoisted_36, _toDisplayString(question.value.favorites || 0), 1), _hoisted_37], 2)])])]), _hoisted_38, _withDirectives(_createElementVNode("div", {
        class: "markdown-body",
        innerHTML: formattedDescription.value
      }, null, 8, _hoisted_39), [[_directive_highlight]])], 64))]), _createElementVNode("div", _hoisted_40, [_hoisted_41, isLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_42, _hoisted_45)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createElementVNode("div", {
        class: _normalizeClass({
          'blur-content': !isFullAccess.value
        }),
        onCopy: _withModifiers(handleCopy, ["prevent"])
      }, [_withDirectives(_createElementVNode("div", {
        class: "markdown-body",
        innerHTML: formattedSolution.value
      }, null, 8, _hoisted_46), [[_directive_highlight]])], 34), !isFullAccess.value ? (_openBlock(), _createElementBlock("div", _hoisted_47, [_hoisted_48, _createElementVNode("div", {
        class: "member-prompt"
      }, [_hoisted_49, _hoisted_50, _createElementVNode("button", {
        class: "subscribe-btn",
        onClick: goToMemberPage
      }, "立即订阅")])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_51, [_createElementVNode("h3", _hoisted_52, [_hoisted_53, _createTextVNode(" 评论区 "), _createElementVNode("span", _hoisted_54, "(" + _toDisplayString(comments.value.length) + ")", 1)]), _createElementVNode("div", _hoisted_55, [_createElementVNode("div", _hoisted_56, [_createElementVNode("img", {
        src: userAvatar.value,
        alt: "用户头像"
      }, null, 8, _hoisted_57)]), _createElementVNode("div", _hoisted_58, [_withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => newComment.value = $event),
        class: "comment-input",
        placeholder: replyState.value.isReplying ? replyState.value.isSecondLevel ? `回复 @${replyState.value.replayUserName} 的评论` : `回复 @${replyState.value.replayUserName}` : '说说你的想法...',
        onKeydown: _withKeys(_withModifiers(submitComment, ["ctrl"]), ["enter"])
      }, null, 40, _hoisted_59), [[_vModelText, newComment.value]]), _createElementVNode("div", _hoisted_60, [_createElementVNode("div", _hoisted_61, [_hoisted_62, replyState.value.isReplying ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        class: "cancel-reply",
        onClick: cancelReply
      }, " 取消回复 ")) : _createCommentVNode("", true)]), _createElementVNode("button", {
        class: "submit-comment",
        onClick: submitComment
      }, [_hoisted_63, _createTextVNode(" " + _toDisplayString(replyState.value.isReplying ? '回复' : '发表评论'), 1)])])])]), _createElementVNode("div", _hoisted_64, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(comments.value, comment => {
        return _openBlock(), _createElementBlock("div", {
          key: comment.id,
          class: "comment-item"
        }, [_createElementVNode("div", _hoisted_65, [_createElementVNode("img", {
          src: resolveAvatar(comment.avatar),
          alt: comment.username
        }, null, 8, _hoisted_66)]), _createElementVNode("div", _hoisted_67, [_createElementVNode("div", _hoisted_68, [_createElementVNode("span", _hoisted_69, _toDisplayString(comment.username), 1), _createElementVNode("span", _hoisted_70, _toDisplayString(comment.time), 1)]), _createElementVNode("div", _hoisted_71, _toDisplayString(comment.content), 1), _createElementVNode("div", _hoisted_72, [_createElementVNode("button", {
          class: _normalizeClass(["action-btn comment-like-btn", {
            'liked': comment.isLiked
          }]),
          onClick: $event => likeComment(comment)
        }, [_hoisted_74, _createElementVNode("span", _hoisted_75, _toDisplayString(comment.likes), 1)], 10, _hoisted_73), comment.username !== _unref(loginUserStore).loginUser?.userName ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "action-btn",
          onClick: $event => replyComment(comment)
        }, [_hoisted_77, _createTextVNode(" 回复 ")], 8, _hoisted_76)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_78, [_createElementVNode("button", {
          class: "action-btn more-btn",
          onClick: _withModifiers($event => toggleMoreMenu(comment.id, false), ["stop"])
        }, _hoisted_81, 8, _hoisted_79), moreMenuState.value.commentId === comment.id && !moreMenuState.value.isReply ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "more-menu",
          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
        }, [comment.username === _unref(loginUserStore).loginUser?.userName ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "menu-item",
          onClick: $event => {
            deleteComment(comment);
            closeMoreMenu();
          }
        }, "🗑️ 删除 ", 8, _hoisted_82)) : _createCommentVNode("", true), comment.username !== _unref(loginUserStore).loginUser?.userName ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "menu-item",
          onClick: $event => {
            reportComment(comment, false);
            closeMoreMenu();
          }
        }, "⚠️ 举报 ", 8, _hoisted_83)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])]), comment.replies && comment.replies.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_84, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(comment.replies, reply => {
          return _openBlock(), _createElementBlock("div", {
            key: reply.id,
            class: "reply-item"
          }, [_createElementVNode("div", _hoisted_85, [_createElementVNode("div", _hoisted_86, [_createElementVNode("div", _hoisted_87, [_createElementVNode("img", {
            src: reply.avatar,
            alt: reply.username,
            class: "reply-avatar"
          }, null, 8, _hoisted_88), _createElementVNode("div", _hoisted_89, [_createElementVNode("span", _hoisted_90, _toDisplayString(reply.username), 1), _hoisted_91, _createElementVNode("span", _hoisted_92, "@" + _toDisplayString(reply.replayUserName), 1), _createElementVNode("span", _hoisted_93, _toDisplayString(reply.time), 1)])])]), _createElementVNode("div", _hoisted_94, _toDisplayString(reply.content), 1), _createElementVNode("div", _hoisted_95, [_createElementVNode("button", {
            class: _normalizeClass(["action-btn comment-like-btn", {
              'liked': reply.isLiked
            }]),
            onClick: $event => likeComment(reply)
          }, [_hoisted_97, _createElementVNode("span", _hoisted_98, _toDisplayString(reply.likes), 1)], 10, _hoisted_96), reply.username !== _unref(loginUserStore).loginUser?.userName ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "action-btn",
            onClick: $event => replyComment(reply, false)
          }, [_hoisted_100, _createTextVNode(" 回复 ")], 8, _hoisted_99)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_101, [_createElementVNode("button", {
            class: "action-btn more-btn",
            onClick: _withModifiers($event => toggleMoreMenu(reply.id, true), ["stop"])
          }, _hoisted_104, 8, _hoisted_102), moreMenuState.value.commentId === reply.id && moreMenuState.value.isReply ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "more-menu",
            onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
          }, [reply.username === _unref(loginUserStore).loginUser?.userName ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "menu-item",
            onClick: $event => {
              deleteReply(comment, reply);
              closeMoreMenu();
            }
          }, "🗑️ 删除 ", 8, _hoisted_105)) : _createCommentVNode("", true), reply.username !== _unref(loginUserStore).loginUser?.userName ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "menu-item",
            onClick: $event => {
              reportComment(reply, true);
              closeMoreMenu();
            }
          }, "⚠️ 举报 ", 8, _hoisted_106)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])])])]);
        }), 128))])) : _createCommentVNode("", true)])]);
      }), 128))])])], 64))])], 2)]), _createVNode(_component_el_dialog, {
        modelValue: reportDialogVisible.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => reportDialogVisible.value = $event),
        title: "举报评论",
        width: "400px",
        "destroy-on-close": "",
        "close-on-click-modal": false,
        class: "report-dialog",
        "append-to-body": true,
        fullscreen: false
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_110, [_createVNode(_component_el_button, {
          onClick: _cache[5] || (_cache[5] = $event => reportDialogVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: submitReport,
          disabled: isSubmittingReport.value
        }, {
          default: _withCtx(() => [isSubmittingReport.value ? (_openBlock(), _createElementBlock("span", _hoisted_111, "提交中...")) : (_openBlock(), _createElementBlock("span", _hoisted_112, "提交"))]),
          _: 1
        }, 8, ["disabled"])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_107, [_hoisted_108, _createVNode(_component_el_radio_group, {
          modelValue: reportReason.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => reportReason.value = $event),
          class: "report-reason-group"
        }, {
          default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(reportReasons, (reason, index) => {
            return _createVNode(_component_el_radio, {
              key: index,
              label: reason
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(reason), 1)]),
              _: 2
            }, 1032, ["label"]);
          }), 64))]),
          _: 1
        }, 8, ["modelValue"]), reportReason.value === '其他' ? (_openBlock(), _createElementBlock("div", _hoisted_109, [_createVNode(_component_el_input, {
          modelValue: customReportReason.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => customReportReason.value = $event),
          type: "textarea",
          rows: 2,
          placeholder: "请输入举报原因（最多200字）",
          maxlength: "200",
          "show-word-limit": ""
        }, null, 8, ["modelValue"])])) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};